module.exports = __webpack_public_path__ + "static/profile-pic-b10781eeb668e429ea041ade509be9c0.jpg";